import React from "react";
import {
  Container,
  Typography,
  Box,
  useTheme,
} from "@mui/material";
import CoopItem from "./CoopItem";
export default function Cooperation() {
  const theme = useTheme();

  const categories = [
    {
      title: "مربیان",
      plans: [
        {
          duration: "سه ماهه",
          price: "۱,۲۰۰,۰۰۰",
          description: "دسترسی به پنل مربی، برنامه‌ریزی تمرین، آمار پایه",
          features: ["پشتیبانی ۲۴/۷", "۵ جلسه آنلاین", "گزارش هفتگی"],
          popular: false,
        },
        {
          duration: "شش ماهه",
          price: "۲,۲۰۰,۰۰۰",
          description: "همه امکانات سه ماهه + تحلیل ویدیویی",
          features: ["پشتیبانی優先", "۱۲ جلسه آنلاین", "گواهی دوره"],
          popular: true,
        },
        {
          duration: "یک ساله",
          price: "۴,۰۰۰,۰۰۰",
          description: "دسترسی کامل به همه ابزارها + منتورینگ اختصاصی",
          features: ["مشاوره VIP", "۲۴ جلسه آنلاین", "دسترسی مادام‌العمر"],
          popular: false,
        },
      ],
    },
    {
      title: "باشگاه‌ها",
      plans: [
        {
          duration: "سه ماهه",
          price: "۲,۵۰۰,۰۰۰",
          description: "مدیریت تیم، اطلاع‌رسانی خودکار، لیگ داخلی",
          features: ["پنل باشگاه", "۳۰ ورزشکار", "گزارش عملکرد"],
          popular: false,
        },
        {
          duration: "شش ماهه",
          price: "۴,۵۰۰,۰۰۰",
          description: "امکانات سه ماهه + سیستم مسابقات آنلاین",
          features: ["پشتیبانی ویژه", "۱۰۰ ورزشکار", "برندینگ اختصاصی"],
          popular: true,
        },
        {
          duration: "یک ساله",
          price: "۸,۰۰۰,۰۰۰",
          description: "جامع‌ترین راهکار حرفه‌ای برای باشگاه شما",
          features: ["مشاوره استراتژیک", "نامحدود", "وبسایت اختصاصی"],
          popular: false,
        },
      ],
    },
  ];

  const items = categories.map((category, idx) => (
    <CoopItem category={category} key={idx} idx={idx}  />
  ));
  return (
    <Box
      sx={{
        minHeight: "100svh",
        py: { xs: 6, md: 5 },
        px: { xs: 2, sm: 3, md: 4 },
        direction: "rtl",
      }}
    >
      <Container maxWidth="xl">
        {/* Header */}
        <Box textAlign="center" mb={{ xs: 4, md: 5 }}>
          <Typography
            variant="h5"
            component={"h2"}
            sx={{
              fontWeight: 800,
              background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              color: "transparent",
              mb: 2,
            }}
          >
            طرح‌های همکاری
          </Typography>
          <Typography
            variant="body2"
            component={"h6"}
            sx={{
              color: "text.secondary",
              maxWidth: "600px",
              mx: "auto",
            }}
          >
            مناسب برای مربیان و باشگاه‌های حرفه‌ای
          </Typography>
        </Box>

        {/* Items  */}
        {items}
      </Container>
    </Box>
  );
}
